const uiDefaultSchema = {
    "classNames": "row"
}
export {uiDefaultSchema}